import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';

import { queryGetUserMonthBonusesForUserMonthGQL } from '../graphql/userMonthBonusesForUserMonthApi';
import { getBonusMonth, getUserId } from '../selectors';
import UserMonthBonusForm from './UserBonusMonthForm';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  bonusMonth: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,

  user: PropTypes.object.isRequired,
  userMonthBonusesForUserMonth: PropTypes.array.isRequired,
});
/* eslint-enabled react/no-unused-prop-types */

const UserBonusMonthWrapper = (props) => {
  const { userMonthBonusesForUserMonth, user } = props;

  return (
    <UserMonthBonusForm
      initialValues={{ members: userMonthBonusesForUserMonth }}
      user={user}
    />
  );
};

UserBonusMonthWrapper.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    bonusMonth: getBonusMonth(state),
    userId: getUserId(state),
  };
};
const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoUserId = branch(
  (props) => { return props.userId === 0; },
  renderNothing,
);

const withNoQueryData = branch(
  (props) => { return props.userMonthBonusesForUserMonth.length === 0; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withNoUserId,
  queryGetUserMonthBonusesForUserMonthGQL,
  withNoQueryData,
);

export default enhance(UserBonusMonthWrapper);
